import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericIdbaService } from '../generic-idba-service.service';
import { GenericIdbaRequestModel } from '../../models/generic-idba-request-model';
import { ParametrosGenericos } from '../../models/generics/parametros-genericos';


@Injectable({
  providedIn: 'root'
})
export class ParametrosGenericosService extends GenericIdbaService {

  declare model: ParametrosGenericos;

  constructor(http: HttpClient) { 
    super(http, new ParametrosGenericos());
    this.programName = "cad/genericos/pargenerico.p";
  }

  pesquisarPorNumero(codigoModulo: string) {
    var request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-pesquisa-parametros-genericos-por-numero";
    request.parameters = { codigoModulo };
    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, { observe: "response" });
  }

  pesquisarPorCodigo(codigoParGenerico: number) {
    var request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-pesquisa-codigo-parametros-genericos";
    request.parameters = { codigoParGenerico };
    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, { observe: "response" });
  }

  pesquisarPorModuloAssunto(modulo: string, assunto: string) {
    var request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-listar-modulo-assunto";
    request.parameters = { modulo, assunto };
    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, { observe: "response" });
  }


}
